import { datadogRum } from '@datadog/browser-rum';
import { Analytics, CheckoutDetails, EventProperties, AnalyticsEvent } from '.';

interface DataDogRumClient {
  setGlobalContextProperty: (key: string, value: unknown) => void;
  setUser: (user: { id: string }) => void;
  addAction: (name: string, context?: EventProperties) => void;
}

const datadog: DataDogRumClient = {
  setGlobalContextProperty(key: string, value: unknown) {
    datadogRum.setGlobalContextProperty(key, value);
  },
  setUser(user: { id: string }) {
    datadogRum.setUser(user);
  },
  addAction(name: string, context?: EventProperties) {
    datadogRum.addAction(name, context);
  },
};

export const datadogClient: Analytics = {
  initialize(): void {
    // noOp - initialization handled by useDataDogRUM hook
  },
  setApplication(): void {
    // noOp
  },
  setSelectedOffer(): void {
    // noOp
  },
  setOrder(): void {
    // noOp
  },
  identify(buyerId: string): void {
    datadog.setGlobalContextProperty('buyer_id', buyerId);
    datadog.setUser({ id: buyerId });
  },
  setCheckoutDetails(details: CheckoutDetails): void {
    const { merchantID, programID } = details;
    datadog.setGlobalContextProperty('merchant_id', merchantID);
    datadog.setGlobalContextProperty('program_id', programID);
  },
  trackLogout(): void {
    // noOp
  },
  track(event: AnalyticsEvent, properties?: EventProperties): void {
    datadog.addAction(event, properties);
  },
  setAdditionalContext(properties: EventProperties): void {
    if ('decibel_session_id' in properties) {
      datadog.setGlobalContextProperty(
        'decibel_session_id',
        properties.decibel_session_id
      );
    }
  },
};
